module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spring-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-part top",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })]), _vm._v(" "), _c('div', {
    staticClass: "spring-spinner-part bottom",
    style: (_vm.spinnerPartStyle)
  }, [_c('div', {
    staticClass: "spring-spinner-rotator",
    style: (_vm.rotatorStyle)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc083e30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/SpringSpinner.vue
// module id = 283
// module chunks = 1